import { config } from './config';

declare global {
  interface Window {
    config: typeof config;
  }
}

// Initialize the config on the window object
window.config = config;

export {}; 